import * as Yup from 'yup';

const schema = Yup.object().shape({
  allergiesToggle: Yup.boolean().required('Please select an option').nullable(),
  allergies: Yup.mixed().when('allergiesToggle', {
    is: true,
    then: Yup.string().required('Please list any allergies or select “No” above.'),
    otherwise: Yup.mixed().notRequired(),
  }),
  conditionsToggle: Yup.boolean().required('Please select an option').nullable(),
  conditions: Yup.mixed().when('conditionsToggle', {
    is: true,
    then: Yup.string().required('Please list any medical conditions or select “No” above.'),
    otherwise: Yup.mixed().notRequired(),
  }),
  medications: Yup.mixed().when('noMedicationsCheckbox', {
    is: false,
    then: Yup.array().of(Yup.string().required('Please list any other medications or check the checkbox below')),
    otherwise: Yup.array().of(Yup.string().notRequired()),
  }),
});

const validation = {
  schema,
};

export default validation;
